import React from 'react';

/** App mark — the same artwork as the home-screen icon (public/icon-192.png) */
export const BrandLogo: React.FC<{ className?: string }> = ({ className = 'w-9 h-9' }) => (
  <span
    className={`${className} relative block rounded-[28%] overflow-hidden ring-1 ring-white/20 shadow-[0_4px_16px_rgba(244,63,94,0.35)]`}
  >
    <img
      src="/icon-192.png?v=2"
      alt=""
      aria-hidden="true"
      width={192}
      height={192}
      className="w-full h-full object-cover"
    />
  </span>
);
